export type ButtonSize = 'sm' | 'default' | 'lg';

export function getIconSizeClass(size: ButtonSize): string {
  switch (size) {
    case 'sm':
      return 'h-4 w-4';
    case 'lg':
      return 'h-6 w-6';
    default:
      return 'h-5 w-5';
  }
}
